module.exports = __webpack_public_path__ + "static/lamia-f6629e82c84c5d7360bb4f1cb330a92d.jpg";